import {
  createNavigableIdForSectionHeading,
  createNavigableIdForSideNavLink,
} from '@/cms/components/utils';

import { SideNavSection } from '../../types';
import { HOMEPAGE_SIDENAV_SCROLL_OFFSET_PX } from './constants';

export function getHomepageSideNavSectionId(section: SideNavSection) {
  return createNavigableIdForSectionHeading(section);
}

export function normalizeHash(hash: string) {
  return hash.replace(/^#/, '');
}

export function clearSectionHash(lastHashRef: { current: string }) {
  if (lastHashRef.current === '') return;

  lastHashRef.current = '';
  window.history.replaceState(
    null,
    '',
    window.location.pathname + window.location.search
  );
}

export function replaceSectionHash(
  section: SideNavSection,
  lastHashRef: { current: string }
) {
  const hash = createNavigableIdForSideNavLink(section);
  const normalizedHash = normalizeHash(hash);

  if (normalizedHash === lastHashRef.current) return;

  lastHashRef.current = normalizedHash;
  window.history.replaceState(null, '', hash);
}

export function scrollToHomepageSideNavSection(section: SideNavSection) {
  const sectionElement = document.getElementById(
    getHomepageSideNavSectionId(section)
  );

  if (!sectionElement) return;

  const top =
    sectionElement.getBoundingClientRect().top +
    window.scrollY -
    HOMEPAGE_SIDENAV_SCROLL_OFFSET_PX;

  window.scrollTo({ top, behavior: 'smooth' });
}

export function getHashSection(sections: SideNavSection[]) {
  if (typeof window === 'undefined') return null;

  const hashId = normalizeHash(window.location.hash);
  const hashSection = sections.find(
    (section) => getHomepageSideNavSectionId(section) === hashId
  );

  return hashSection;
}

export function getActiveTag(sections: SideNavSection[]) {
  if (typeof window === 'undefined') return sections[0]?.tag ?? '';

  const hashSection = getHashSection(sections);

  return hashSection?.tag ?? sections[0]?.tag ?? '';
}
